<template>
    <div class="cs4-cart__itemsBorder" :class="{'cs4-cart__itemsBorder--active': showBonusCTA && isBonusActive }">
        <div class="cs4-cart__items " :class="[showBonusCTA ? 'cs4-cart__items--bonusVisible' : 'cs4-cart__items--bonusHidden' ]">
        <div class="cs4-cart__ctaBonusBar" :class="{'cs4-cart__ctaBonusBar--active': showBonusCTA && isBonusActive }" v-if="showBonusCTA">
            <div class="cs4-cart__ctaBonusBar__title">{{ isBonusActive? dictionary.bonusActive : dictionary.bonusInactive }}</div>
            <div class="cs4-cart__ctaBonusBar__switch" >
                <input type="checkbox" class="cs4-cart__ctaBonusBar__switchCheckbox" :checked="isBonusActive">
                <span class="cs4-cart__ctaBonusBar__switchSlider" v-on:click="toggleBonusActive()"></span>
            </div>
            <div class="cs4-cart__ctaBonusBar__subtitle">{{ dictionary.bonusActiveExplanation }}</div>
        </div>
        <CartItem v-for="cartItem of cartItems" :key="cartItem.key" :currentItem="cartItem" @deleteCartItem="deleteCartItem" :dictionary="dictionary" :bonusOfferKey="bonusOfferItemKey"></CartItem>
    </div>
    </div>
    
</template>

<script>
import CartItem from './CartItem.vue';
export default{
    props: ['cartItems','dictionary','showBonusCTA','isBonusActive','bonusOfferItemKey'],
    emits: ['toggleBonusActive'],
    data(){
    },
    methods: {
        deleteCartItem(key){
            this.$emit('deleteCartItem', key);
        },
        toggleBonusActive(){
            this.$emit('toggleBonusActive');
        }
    },
    components: {
        CartItem
    }

}
</script>

<style lang="scss" scoped>
    .cs4-cart__items {
        background: #99e2cd;

        &--bonus{
            &Visible{
                padding: 25px 15px 15px 15px;
                border-radius: 22px;
            }

            &Hidden{
                padding: 15px 15px 5px;
                border-radius: 15px;
            }
            
        }

        &Border{
            margin: 15px;
            border: 3px solid #99e2cd;
            border-radius: 25px;

            &--active{
                border: none;
                background: linear-gradient(90deg, #F94DD7 0.08%, #0577B7 97.66%);
                border-radius: 25px;
                padding: 3px;
            }
        }
    }

    .cs4-cart__ctaBonusBar{
        background: linear-gradient(90deg, #CD8DC0 0.32%, #4C7A94 98.11%);
        margin: -28px -18px 10px;
        border-radius: 23px 23px 0 0;
        display: grid;
        grid-template-columns: 1fr 60px;
        grid-template-rows: 30px 30px;
        height: 75px;
        text-align: left;
        padding: 10px 20px;

        &--active{
            background: linear-gradient(90deg, #F94DD7 0.32%, #0577B7 98.11%);
        }

        &__title{
            font-weight: 600;
            font-size: 14px;
            display: flex;
            align-items: center;
        }

        &__subtitle{
            grid-column: 1 / span 2;
            font-weight: 600;
            font-size: 12px;
            display: flex;
            align-items: center;
            padding: 3px 0 5px;
        }

        &__switch{
            position: relative;
            width: 50px;
            height: 27px;
            display: flex;
            justify-self: flex-end;
            cursor: pointer;

            &Checkbox{
                opacity: 0;
                width: 0;
                height: 0;

                &:checked + .cs4-cart__ctaBonusBar__switchSlider{
                    background-color: white;
                }

                &:checked + .cs4-cart__ctaBonusBar__switchSlider:before{
                    -webkit-transform: translateX(23px);
                    -ms-transform: translateX(23px);
                    transform: translateX(23px);
                }
            }

            &Slider{
                position: absolute;
                cursor: pointer;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background-color: #fff;
                -webkit-transition: .4s;
                transition: .4s;
                border-radius: 34px;

                &:before{
                    position: absolute;
                    content: "";
                    height: 21px;
                    width: 21px;
                    left: 3px;
                    bottom: 3px;
                    background-color: #3887CF;
                    -webkit-transition: .4s;
                    transition: .4s;
                    border-radius: 50%;
                }
            }
        }
    }
</style>